<!--
  Skip link must be the first focusable element on the page. It is visually
  hidden until focused (see .skip-link in styles.scss) and satisfies WCAG 2.4.1
  Bypass Blocks: without it, keyboard and screen reader users re-tab the whole
  header and primary nav on every route change.
-->
<nav aria-label="Skip links">
  <a class="skip-link" href="#body-container">Skip to main content</a>
</nav>

<div class="app-container">
  @if (
    !isManagerRoute() &&
    !isAnalyticsRoute() &&
    !isAccountRoute() &&
    !isPublicPageRoute() &&
    !isSharedReportRoute()
  ) {
    <!--
      MOBILE.1 R2. ONE OWNER OF VIA AT EVERY WIDTH.

      The rail and cpd-via-button both answer askQuestion$, the action every
      "Ask Via" pill in the app sends; with two mounted, a question is handled
      twice. So: 960px and up, the rail on a desktop and the floating button on
      an iPad in landscape, as before; under 960px, neither, and the bottom bar's
      Ask Via (in cpd-header) instead. Under 960px the rail used to mount at
      zero width with its icons straddling the left edge of the screen.
    -->
    @if (!(isMobile$ | async) && !(isNarrow$ | async)) {
      <nav aria-label="Primary">
        <cpd-sidebar [isChatViaOpen]="isOpenChatVia$ | async"></cpd-sidebar>
      </nav>
    }

    <cpd-chat-via [isChatViaOpen]="isOpenChatVia$ | async"></cpd-chat-via>

    <div class="site-container-wrapper">
      <section
        #siteContainer
        class="relative antialiased"
        id="site-container"
        (window:resize)="onResized(siteContainer)"
      >
        <header role="banner">
          <cpd-header></cpd-header>
        </header>

        <!--
          tabindex="-1" makes this a programmatic focus target for the skip
          link. Without it the browser moves the scroll position but leaves
          focus behind, so the next Tab returns to the top of the page.
        -->
        <main
          id="body-container"
          tabindex="-1"
          [ngClass]="{
            'pb-0': isAboutRoute(),
            'background-ghost-white': isAboutRoute()
          }"
        >
          <router-outlet></router-outlet>
        </main>

        <footer role="contentinfo">
          <cpd-footer></cpd-footer>
        </footer>

        <aside aria-label="Help and support">
          @if (!isErrorRoute()) {
            <cpd-tutorial-button class="tutorial-button"></cpd-tutorial-button>
          }

          @if ((isMobile$ | async) && !(isNarrow$ | async)) {
            <cpd-via-button class="cpd-via-button"></cpd-via-button>
          }
        </aside>
      </section>
    </div>
  } @else {
    <!--
      Manager, analytics, account and the public portfolio page render without
      the shell. For the first three that is a layout choice; for /p/:slug it is
      the requirement (spec 07 section 1, acceptance criteria 1 and 4): the
      visitor is not the member and must see no goal counter, no account
      control and no sign-in. They still
      need a main landmark, or landmark navigation has nothing to target and
      the skip link above resolves to nothing (WCAG 1.3.1 / 2.4.1).
    -->
    <main id="body-container" tabindex="-1">
      <router-outlet></router-outlet>
    </main>
  }
</div>

@if (!isErrorRoute()) {
  <cpd-alert [canClose]="true"></cpd-alert>
}
<cpd-spinner [show]="isLoading$ | async"></cpd-spinner>
